import React from "react";
import PostCategoryBadge from "../../../../components/PostCategoryBadge";
import { truncateText } from "../../../../util";
import "./index.css";

const formatDescription = (description, onClick, maxLength) => {
  if (description.length > maxLength) {
    return (
      <span>
        {truncateText(description, maxLength)}
        <a onClick={onClick}> Read more </a>
      </span>
    );
  }
  return description;
};
const PostCardFooter = ({ title, description, category, caseType, onClick, maxLength = 150, promoted = false }) => (
  <footer className="-card-content">
    {(title || description) && (
      <article>
        {!promoted && <br />}
        {title && (
          <span onClick={onClick}>
            <h3 className="-card-title">{title}</h3>
          </span>
        )}
        {description && <p className="-card-meta">{formatDescription(description, onClick, maxLength)}</p>}
        {category && <PostCategoryBadge category={category} caseType={caseType} />}
      </article>
    )}
  </footer>
);

export default PostCardFooter;



// WEBPACK FOOTER //
// ./src/components/PostsList/components/PostCardFooter/index.js